<div class="error flex flex-col justify-center items-center h-screen">
  <div class="card p-20 flex flex-col justify-center items-center text-center rounded-2xl">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-20 h-20 text-red-500">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z" />
    </svg>

    <h1 class="text-4xl mb-12">Non hai i permessi per accedere a questa pagina</h1>
    <button class="e-primary e-danger text-xl" (click)="home()">Torna alla home</button>
    <button class="e-primary e-danger text-xl" (click)="login()">Torna alla login</button>
  </div>



</div>


